import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The 7d / 28d / 90d switch every windowed board carries.
 *
 * It was three buttons written out by hand on the engagement board, the
 * events board and the event page, each with its own copy of the pill styles.
 * One component, so a fourth window - or a different set of windows - is a
 * change here and not in three templates.
 */
@Component({
  selector: 'app-range-switch',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="range" role="group" aria-label="Time range">
      <button
        *ngFor="let d of options"
        type="button"
        [class.on]="days === d"
        [attr.aria-pressed]="days === d"
        (click)="pick(d)"
      >
        {{ d }}d
      </button>
    </div>
  `,
  styles: [
    `
      .range {
        display: flex;
        gap: 6px;
      }
      button {
        background: none;
        border: 1px solid rgba(18, 51, 47, 0.14);
        border-radius: 999px;
        padding: 6px 14px;
        font: 600 12.5px 'Instrument Sans', system-ui, sans-serif;
        color: #5e5a57;
        cursor: pointer;
      }
      button.on {
        background: #12332f;
        border-color: #12332f;
        color: #fff;
      }
    `,
  ],
})
export class RangeSwitchComponent {
  @Input() days = 28;
  @Input() options: number[] = [7, 28, 90];
  @Output() daysChange = new EventEmitter<number>();

  pick(days: number): void {
    if (days === this.days) return;
    this.days = days;
    this.daysChange.emit(days);
  }
}
